import * as React from 'react'

import { Box, Button, Text } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import i18n from 'modules/core/lib/i18n'

import { FLOWS } from 'modules/contracts/components/FlowSelectorModal/constants'
import { ApprovalStatus } from 'modules/contracts/lib/enums'

type CardHeaderProps = {
  canApproveOrReject: boolean
  requestStatus: ApprovalStatus
  actionType: string
  onClickReject: () => void
  onClickApprove: () => void
}

const CardHeader = ({
  canApproveOrReject,
  requestStatus,
  actionType,
  onClickReject,
  onClickApprove,
}: CardHeaderProps) => {
  const title = (() => {
    if (actionType === FLOWS.promotion) {
      switch (requestStatus) {
        case ApprovalStatus.pending:
          return i18n.t('contract_versions.approval_page.promotion.card_info.title')
        case ApprovalStatus.approved:
          return i18n.t('contract_versions.approval_page.promotion.card_info.title_approved')
        case ApprovalStatus.rejected:
          return i18n.t('contract_versions.approval_page.promotion.card_info.title_rejected')
        default:
          throw new Error('Invalid request status provided.')
      }
    } else if (actionType === FLOWS.evolution) {
      switch (requestStatus) {
        case ApprovalStatus.pending:
          return i18n.t('contract_versions.approval_page.evolution.card_info.title')
        case ApprovalStatus.approved:
          return i18n.t('contract_versions.approval_page.evolution.card_info.title_approved')
        case ApprovalStatus.rejected:
          return i18n.t('contract_versions.approval_page.evolution.card_info.title_rejected')
        default:
          throw new Error('Invalid request status provided.')
      }
    }

    return ''
  })()

  return (
    <Box flexDirection="row" width="full" justifyContent="spaceBetween" alignItems="center">
      <Text size="300" weight="semibold">
        {title}
      </Text>
      {canApproveOrReject && (
        <Box flexDirection="row" paddingLeft="s32" gap="s8">
          <Button type="negative" onClick={() => onClickReject()}>
            {i18n.t('common.reject')}
          </Button>
          <Button type="positive" onClick={() => onClickApprove()}>
            {i18n.t('common.approve')}
          </Button>
        </Box>
      )}
    </Box>
  )
}

export default observer(CardHeader)
